export default __webpack_public_path__ + "static/media/go-c.ccff0ff1.png";